module.exports = __webpack_public_path__ + "img/budweisek.0cb8560f.png";